import { produce } from 'immer'

import type { SettingsActions } from './actions'
import { ActionTypes } from './actions'

import type { Domain } from '@/types/domain'
import type { Customize } from '@/types/settings'

export const initialState = {
  loading: false,
  sidebarCompact: false,
  sidebarMobile: false,
  sidebarOnHover: false,
  tenant: null as Domain | null,
  customize: null as Customize | null,
}

export default function reducer(
  state: typeof initialState,
  action: SettingsActions,
) {
  switch (action.type) {
    case ActionTypes.SETTING_LOADING:
      return produce(state, (draft) => {
        draft.loading = action.payload
      })

    case ActionTypes.SETTING_SIDEBAR_COMPACT:
      return produce(state, (draft) => {
        draft.sidebarCompact = action.payload
      })

    case ActionTypes.SETTING_SET_TENANT:
      return produce(state, (draft) => {
        draft.tenant = action.payload
      })

    case ActionTypes.SETTING_CUSTOMIZE:
      return produce(state, (draft) => {
        draft.customize = action.payload
        // draft.customize.menu_orientation = 'landscape'
      })

    default:
      return state
  }
}
